module.exports = __webpack_public_path__ + "static/media/collage2_2_480.e031cbbb.png";